module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love the Brandt and Donnelly Caper series by")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("X")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("AVIER")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("AYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("A Wedding to Die For")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This full length novel is going in my permanent library and I will be reading it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Love Bytes")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I am not one for mysteries and suspense, but when Xavier is the author then you can damn well bet, I am one of the first ones in line to get it. He always gives a person amazing stories with two very hot guys who just happen to carry guns and badges.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("A Wedding to Die For")]), _vm._v(" is a great addition for this series.  Like the previous books, this one will have you turning the pages anxious to see what will happen next. It will also leave you dying to see what the author has planned next for our main characters and hoping the next book will be out soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Literary Nymphs")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Once again, Xavier Mayne has won me over and entertained me. Parts of this book were darker than I am used to from this author, but it was definitely one of my favorites of his so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—The Novel Approach")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Wrestling Demons")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This is a fantastic series. I really enjoyed the first installment, "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Frat House Troopers")]), _vm._v(". And like with the first story I underestimated the book. I thought cute, sexy, fun, silly. And it was all of those things, but there was an emotional depth to the characters, plot, scenes, and writing that was a wonderful surprise.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Gay List Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“It reached out and drew me close—made me feel comfortable with some old and new friends. Loved it!”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Hearts on Fire Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0